import $axios from 'plugins/axios'
import $api from 'plugins/api'
import $aide from 'components/system-aide'
import list from '@/components/list'
import SkeletonScreen from '@/components/skeleton-screen'
import CustomLayout from '@/components/custom-layout'
const Components = {}
Object.assign(Components, {
  list,
  SkeletonScreen,
  CustomLayout
})
export default {
  install: (Vue, options) => {
    Object.assign(Vue.prototype, {
      $ajax: $axios,
      $api,
      $aide
    })
    Object.keys(Components).forEach(key => {
      Vue.component(key, Components[key])
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/inject/index.js